export function resolveQuestions(
  questionRefs: string[],
  questionRegistry: Record<string, PolicyFormQuestion>,
): PolicyFormQuestion[] {
  return questionRefs.map(ref => {
    const question = questionRegistry[ref];
    if (!question) {
      throw new Error(`Question with ref "${ref}" not found in registry`);
    }
    return question;
  });
}

export function getQuestionByRef(
  questionRef: string,
  questionRegistry: Record<string, PolicyFormQuestion>,
): PolicyFormQuestion {
  const question = questionRegistry[questionRef];
  if (!question) {
    throw new Error(`Question with ref "${questionRef}" not found in registry`);
  }
  return question;
}
